import React from 'react'
import "./products.css"
import ShopProduct from './ShopProduct/ShopProduct'

function ShopProducts({products,titleText, innerpage} : any) {
  return (
    <div className='hd-container'>
      {!innerpage && <div className="sec-heading">{titleText}</div>}
      <div className="hd-products">
        {products?.map((item: any) => (
          <ShopProduct key={item.id} id={item.id} data={item.attributes}/>
        ))}
      </div>
    </div>
  )
}

export default ShopProducts
